var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import APButton from '../APButton';
import APIcon from '../APIcon';
import { readFile } from '../../../helpers/fileHelpers';
import { maxFileSize } from '../../../helpers/formValidations';
import './APUpload.css';
var baseClass = 'ap-upload';
var APUploadInner = function (_React$Component) {
  _inherits(APUploadInner, _React$Component);
  function APUploadInner() {
    _classCallCheck(this, APUploadInner);
    var _this = _possibleConstructorReturn(this, (APUploadInner.__proto__ || Object.getPrototypeOf(APUploadInner)).call(this));
    _this.onChange = function (e) {
      var _this$props = _this.props,
        name = _this$props.input.name,
        customChange = _this$props.customChange;
      var file = e.target.files[0];
      if (file) {
        readFile(file, function (imgSrc) {
          customChange(name, {
            file: file,
            imgSrc: imgSrc
          });
          setTimeout(function () {
            return _this.setState({
              file: file,
              imgSrc: imgSrc,
              hasFile: true
            });
          });
        });
      } else {
        _this.setState({
          file: null,
          imgSrc: null,
          hasFile: false
        });
        customChange(name, null);
      }
    };
    _this.clearField = function () {
      var onChange = _this.props.input.onChange;
      _this.setState({
        file: null,
        imgSrc: null
      });
      onChange(null);
    };
    _this.onFocus = function () {
      _this.setState({
        focused: true,
        hasFocused: true
      });
    };
    _this.onBlur = function () {
      _this.setState({
        focused: false
      });
    };
    _this.isImage = function (fileName) {
      var parts = fileName.split('.');
      var ext = parts[parts.length - 1];
      return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
    };
    _this.state = {
      file: null,
      hasFocused: false,
      focused: false,
      hasFile: false
    };
    return _this;
  }
  _createClass(APUploadInner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classModifiers = _props.classModifiers,
        customClass = _props.customClass,
        info = _props.info,
        placeholder = _props.placeholder,
        label = _props.label,
        acceptedFiles = _props.acceptedFiles,
        error = _props.meta.error,
        alt = _props.alt;
      var _state = this.state,
        file = _state.file,
        hasFocused = _state.hasFocused,
        focused = _state.focused,
        hasFile = _state.hasFile,
        imgSrc = _state.imgSrc;
      var bemClasses = getBEMClasses(baseClass, customClass);
      return React.createElement('div', {
        className: bemClasses('', {
          hasFile: hasFile
        })
      }, React.createElement('div', {
        className: 'form-group ' + bemClasses('wrapper', classModifiers + ' ' + (hasFile ? 'hasFile' : ''))
      }, React.createElement('div', {
        className: bemClasses('children', classModifiers)
      }, file && this.isImage(file.name) && React.createElement('div', {
        className: bemClasses('img-wrapper')
      }, React.createElement('img', {
        src: imgSrc,
        className: bemClasses('preview'),
        alt: alt
      }))), React.createElement('div', {
        className: bemClasses('label', classModifiers) + ' ' + (hasFile ? bemClasses('label', ['hasFile']) : '')
      }, file ? file.name : placeholder, file && React.createElement('span', {
        className: bemClasses('cancel-btn', classModifiers),
        onClick: this.clearField
      }, React.createElement(APIcon, {
        name: 'cancel',
        classModifiers: 'danger',
        customClass: bemClasses('image')
      }))), React.createElement('label', {
        className: bemClasses('input-box')
      }, React.createElement(APButton, {
        customClass: bemClasses('btn'),
        type: 'button'
      }, label), React.createElement('input', {
        type: 'file',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        className: bemClasses('input'),
        value: '',
        accept: acceptedFiles
      }))), info && React.createElement('div', {
        className: 'form-text-muted ' + bemClasses('info')
      }, info), (hasFocused || focused) && hasFile && !file && error && React.createElement('div', {
        className: bemClasses('error')
      }, this.context.t(error)));
    }
  }]);
  return APUploadInner;
}(React.Component);
APUploadInner.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
};
APUploadInner.propTypes = {
  name: PropTypes.string,
  customClass: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool
};
APUploadInner.contextTypes = {
  t: PropTypes.func.isRequired
};
var APUpload = function APUpload(props) {
  var maxSize = function maxSize(value) {
    var maxSize = props.maxSize;
    if (maxSize) return maxFileSize(value, maxSize);
  };
  var validators = props.validate ? [].concat(_toConsumableArray(props.validate), [maxSize]) : [maxSize];
  return React.createElement(Field, Object.assign({
    component: APUploadInner
  }, props, {
    validate: validators,
    name: props.name
  }));
};
APUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};
APUpload.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  placeholder: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autoFocus: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  customChange: PropTypes.func
};
export default APUpload;